export interface StudioVideoPreloadCandidate {
  assetId: string;
  url: string;
  startMs: number;
  endMs: number;
  hidden: boolean;
}

export function selectStudioVideoPreloadUrls(
  candidates: StudioVideoPreloadCandidate[],
  playheadMs: number,
  options: { horizonMs?: number; limit?: number } = {},
): string[] {
  const horizonMs = options.horizonMs ?? 30_000;
  const limit = options.limit ?? 6;
  const seen = new Set<string>();
  return candidates
    .filter(candidate => (
      !candidate.hidden
      && candidate.endMs >= playheadMs - 1000
      && candidate.startMs <= playheadMs + horizonMs
    ))
    .sort((a, b) => a.startMs - b.startMs)
    .flatMap(candidate => {
      if (!candidate.url || seen.has(candidate.url)) return [];
      seen.add(candidate.url);
      return [candidate.url];
    })
    .slice(0, limit);
}
